<template>
  <cy-dialog
    :visible="visible"
    title=" "
    width="680px"
    :height="'480px'"
    :footer="false"
    justify-content="flex-start"
    @close="handleClose"
  >
    <cy-form ref="loginFormRef" :model="loginForm">
      <div class="login">
        <h2 class="login-text" v-if="!imgCodePopVisible && !smsCodePopVisible">登录</h2>
        <h2 class="login-text" v-if="imgCodePopVisible">填写图形验证码</h2>
        <h2 class="login-text" v-if="smsCodePopVisible">请输入验证码</h2>
        <div class="cellphpne" v-if="smsCodePopVisible">已发送至{{ loginForm.cellphone}}</div>
        <cy-form-item
          field="cellphone"
          v-if="!imgCodePopVisible && !smsCodePopVisible"
          :rules="[
            {
              message: t('loginModal.pleaseEnterCellPhone'),
              validator: (newValue) => newValue,
            },
          ]"
        >
          <div class="input flex-start">
            <!-- <div class="input-prefix">+86</div> -->
            <input
              v-model="loginForm.cellphone"
              type="text"
              v-focus
              @focus="clearValidate"
              :placeholder="t('loginModal.pleaseEnterCellPhone')"
              maxlength="11"
              :style="{ width: '100%' }"
            />
            <div
              class="clear-icon iconfont icon-guanbiicon"
              v-show="loginForm.cellphone"
              @click="clearForm('cellphone')"
            ></div>
          </div>
        </cy-form-item>
        <cy-form-item
          v-if="imgCodePopVisible"
          field="imageCode"
          :rules="[
            {
              message: t('loginModal.pleaseEnterImageCode'),
              validator: (newValue) => newValue,
            },
          ]"
        >
          <div class="input m-t-36 flex-between" :style="{ alignItems: 'start' }">
            <div class="short-input">
              <input
                v-model="loginForm.imageCode"
                type="text"
                @focus="clearValidate"
                :placeholder="t('loginModal.pleaseEnterImageCode')"
                maxlength="4"
                :style="{ width: '100%' }"
              />
              <div
                class="clear-icon iconfont icon-guanbiicon"
                v-show="loginForm.imageCode"
                @click="clearForm('imageCode')"
              ></div>
            </div>
            <div class="input-prefix" :style="{ marginLeft: '8px' }">
              <img :src="imageCode" alt="" class="image-code" @click="getImageCode" />
              <span class="image-tool" @click="getImageCode">看不清？点击刷新</span>
            </div>
          </div>
        </cy-form-item>
        <cy-form-item
          field="smsCode"
          v-if="smsCodePopVisible"
          :rules="[
            {
              message: t('loginModal.pleaseEnterSmsCode'),
              validator: (newValue) => newValue,
            },
          ]"
        >
          <div class="input no-border m-t-36 flex-between">
            <div class="short-input">
              <!-- <input
                v-model="loginForm.smsCode"
                type="text"
                @focus="clearValidate"
                @keydown.enter="login"
                :placeholder="t('loginModal.pleaseEnterSmsCode')"
                :style="{ width: '100%' }"
                maxlength="6"
              /> -->
              <CodeInput v-model="loginForm.smsCode"
                mode="line"
                style="width: 100%;"
                :space="10"
                :maxlength="authCodeLength"
                hairline>
              </CodeInput>
              <div
                class="clear-icon iconfont icon-guanbiicon"
                
                v-show="loginForm.smsCode"
                @click="clearForm('smsCode')"
              ></div>
            </div>
          </div>
          <div
              style="margin-top: 40px;color:#A9823E;"
              class="input-prefix get-code"
              v-if="isShowGetCodeButton"
              @click="getPhoneCode"
            >
              重新{{ t("loginModal.getSmsCode") }}
            </div>
            <div class="input-prefix get-code" style="margin-top: 40px;" v-else>{{ downCount }}s后重新获取验证码</div>
        </cy-form-item>

        <div @click="getPhoneCode" v-if="!imgCodePopVisible && !smsCodePopVisible" class="login-btn m-t-36" v-btn-loading.isLock="loginLoading">
          <span>
            {{ loginLoading ? t("loginModal.loging") : '获取验证码' ||  t("loginModal.login") }}
          </span>
        </div>
        <cy-form-item v-if="isShowPolicy && !imgCodePopVisible && !smsCodePopVisible" field="isCheckPolicy">
          <div class="footer-policy">
            <cy-checkbox
              v-model="isCheckPolicy"
              checkboxType="round"
              wrapMarginLeft="0px"
            ></cy-checkbox>
            <div class="policy-text">
              <span class="gray-text">{{ t("loginModal.readAgree") }} </span>
              <span
                v-for="(item, index) in policyList"
                :key="item.id"
                class="title-text"
                @click="showPolicyModel(item.id)"
                >&nbsp;{{`${t('system.leftBookPunctuation')}`}}{{ item.policyName }}{{`${t('system.rightBookPunctuation')} `}}<span
                  v-if="index !== policyList.length - 1"
                  class="gray-text"
                  >{{ t("loginModal.and") }} </span
                >
              </span>
              <span class="gray-text">{{ t("loginModal.readAgree2") }}</span>
            </div>
          </div>
        </cy-form-item>
        <div v-if="imgCodePopVisible" class="login-btn m-t-84 ">
          <div @click="handleClose" class="half-btn cancel">取消</div>
          <span class="gap"></span>
          <div class="half-btn ok" @click="getPhoneCode" v-btn-loading.isLock="loginLoading">确定</div>
        </div>
        <div v-if="smsCodePopVisible" class="login-btn m-t-34" >
          <div @click="handleClose" class="half-btn cancel">取消</div>
          <div class="gap"></div>
          <div @click="login" class="half-btn ok" v-btn-loading.isLock="loginLoading">确定</div>
        </div>
      </div>
    </cy-form>
  </cy-dialog>

  <!-- 隐私弹窗 -->
  <cy-dialog
    :visible="policyModelVisible"
    :title="policyInfo.policyName"
    bgColor="transparent"
    :footer="false"
    @close="handleClosePolicyModel"
  >
    <div
      :style="{ padding: '20px', height: '450px', marginTop: '10px' }"
      v-html="policyInfo.policyContent"
    ></div>
  </cy-dialog>
  <!-- 隐私确认弹窗 -->
  <cy-dialog
    :visible="confirmPolicy"
    :hidenClose="true"
    :width="'384px'"
    :height="'170px'"
    :confirmText="t('loginModal.confirm')"
    :cancelText="t('loginModal.notConfirm')"
    @confirm="handleConfirmPolicyConfirm"
    @close="handleConfirmPolicyClose"
  >
    <div>
      {{
        `${t("loginModal.readAgree")}${policyList
          .map((v) => `${t('system.leftBookPunctuation')}${v.policyName}${t('system.rightBookPunctuation')}`)
          .join(t("loginModal.and"))}`
      }}
    </div>
  </cy-dialog>
</template>
<script setup lang="ts">
import { defineExpose } from "vue";
import useLoginPageState from "./login.state";
import CyDialog from "@/components/ui/cy-dialog.vue";
import CyForm from "@/components/ui/cy-form.vue";
import CyFormItem from "@/components/ui/cy-form-item.vue";
import CodeInput from "@/components/base/login/code-input.vue";
import { t } from "@/locale";

const {
  visible,
  isShowPolicy,
  policyList,
  isCheckPolicy,
  policyModelVisible,
  policyInfo,
  loginForm,
  isShowGetCodeButton,
  downCount,
  imgCodePopVisible,
  smsCodePopVisible,
  authCodeLength,
  imageCode,
  loginLoading,
  loginFormRef,
  // smsStyle,
  confirmPolicy,
  showLoginModal,
  getPhoneCode,
  getImageCode,
  login,
  handleClose,
  handleClosePolicyModel,
  showPolicyModel,
  clearValidate,
  clearForm,
  handleConfirmPolicyClose,
  handleConfirmPolicyConfirm,
} = useLoginPageState();

defineExpose<{
  showLoginModal: () => any;
}>({
  showLoginModal,
});
</script>
<style scoped lang="less">
.clear-icon {
  cursor: pointer;
  font-size: 16px;
  line-height: 16px;
  transition: all 0.2s;
}
input[type="text"] {
  border: none;
  outline: none;
  margin-left: 8px;
  font-size: 15px;
  font-weight: bold;
  line-height: 21px;
  // letter-spacing: 1px;
  background: transparent;
  &::-webkit-input-placeholder {
    color: #b2b2b2;
    letter-spacing: 0px;
  }
}
input[type="checkbox"] {
  border: none;
  outline: none;
}
.m-t-34 {
  margin-top: 34px;
}
.m-t-36 {
  margin-top: 36px;
}
.m-t-84 {
  margin-top: 84px;
}
.short-input {
  display: flex;
  align-items: baseline;
  flex: auto;
  input {
    margin-left: 0px;
  }
}
.login {
  padding: 20px 41px 41px 41px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  .login-text {
    font-size: 22px;
    font-weight: bold;
    color: @common-text-color;
    line-height: 30px;
    text-align: center;
    margin-bottom: 40px;
  }
  .login-btn {
    height: 54px;
    background: rgba(169, 130, 62, 1);
    outline: none;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.4s;
    .gap{
      width: 16px;
      background-color: rgb(255, 255, 255);
      display: block;
      height: 100%;
      flex-shrink: 0;
    }
    .half-btn{
      line-height:53px;
      height:100%;
      border:1px solid #999;
      background-color:#fff;
      text-align: center;
      flex-grow:1;
      align-items:center;
      &.ok{
        text-align: center;
        flex-grow:1;
        color:#fff;
        background-color: #a9823e;
      }
    }
    &:hover {
      background: rgba(169, 130, 62, 0.8);
    }
    span {
      font-size: 15px;
      font-weight: bold;
      color: var(--vt-c-white);
      line-height: 21px;
    }
  }
  .input {
    height: 38px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    align-items: baseline;
    &.flex-start {
      justify-content: start;
    }
    &.flex-between {
      justify-content: space-between;
    }
    .input-prefix {
      font-size: 15px;
      font-weight: bold;
      color: @common-text-color;
      line-height: 21px;
      &.get-code {
        cursor: pointer;
        margin-left: 8px;
      }
    }
    .image-code {
      width: 140px;
      height: 50px;
      transform: translateY(-13px);
      cursor: pointer;
      display: block;
    }
    .image-tool{
      color:#A9823E;
      cursor:pointer;
      z-index: 20;
      display:block;
      text-align: right;
    }
  }
  .no-border{
    border: none;
  }
  .footer-policy {
    margin-top: 22px;
    display: flex;
    .policy-text {
      margin-left: 4px;
      font-size: 15px;
      // display: flex;
      align-items: center;
      // flex-wrap: wrap;
    }
    .gray-text {
      color: rgba(136, 136, 136, 1);
      line-height: 21px;
    }
    .title-text {
      color: rgba(0, 0, 0, 1);
      cursor: pointer;
      transition: all 0.1s;
      font-weight: bold;
      &:hover {
        color: rgba(169, 130, 62, 0.8);
      }
    }
  }
}
:deep(.form-message) {
  margin-left: 0px !important;
}
:deep(.checkbox) {
  align-items: unset !important;
  line-height: 22px !important;
}
</style>
